<script lang="ts">
    import { onMount } from "svelte";
    import gsap from "gsap";

    import SinusWave from "../icons/SinusWaveIcon.svelte";

    onMount(() => {
        const boldPath = document.querySelector<SVGPathElement>("#waveBold path");
        const lightPath = document.querySelector<SVGPathElement>("#waveLight path");
        const pageloader = document.querySelector("#pageloader");
        const bar = document.querySelector("#bar");

        gsap.set(boldPath, {
            strokeDashoffset: -boldPath.getTotalLength(),
            strokeDasharray: boldPath.getTotalLength(),
        });
        // gsap.set(pageloader, {
        //     clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        // });

        const tl = gsap.timeline();
        tl.to(lightPath, {
            opacity: 1,
            duration: 0.5,
        });
        tl.to(
            boldPath,
            {
                strokeDashoffset: -boldPath.getTotalLength() * 3,
                ease: "power1.inOut",
                duration: 2,
            },
            ">-=.5"
        );
        tl.to(
            pageloader,
            {
                opacity: 0,
                duration: 0.5,
            },
            ">-=1"
        );
        tl.to(pageloader, {
            display: "none",
        });
    });
</script>

<div id="pageloader">
    <div id="waves">
        <div id="waveLight"><SinusWave /></div>
        <div id="waveBold"><SinusWave /></div>
    </div>
    <div id="bar" />
</div>

<style lang="scss">
    @import "./src/vars";
    #bar {
        position: absolute;
        left: -2em;
        top: 0;
        width: 2em;
        background-color: $yellow;
        height: 100%;
        z-index: 2;
    }
    #waves {
        position: relative;
        width: 100%;
        height: 100%;
        transform: scaleX(1.02);
    }

    #pageloader {
        width: 100vw;
        height: 100vh;
        background-color: $grayDark;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100000;
        overflow-x: visible;

        :global(svg) {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 100%;
            height: auto;
            overflow: visible;
            :global(path) {
                stroke-width: 1em;
                stroke: $yellow;
                stroke-linecap: round;
                fill: none;
            }
        }
        #waveLight {
            :global(path) {
                stroke-width: 0.25em !important;
                stroke: $gray !important;
                opacity: 0;
            }
        }
    }
</style>
